var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import OrderBookSideBar from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBar";
import { EOrderBookStatus, ESidebarActioningFrom, ETransactionType, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import MutualFundTransactionsTable from "@frameworks/shared-library/components/Orderbook/common/MutualFundTransactionsTable/MutualFundTransactionsTable";
import { useNavigate } from "react-router-dom";
var AllTransactions = function (props) {
    var _a;
    var openSB = props.openSB, setOpenSB = props.setOpenSB, selectedRowDetails = props.selectedRowDetails, setSelectedRowDetails = props.setSelectedRowDetails, setOpenTOC = props.setOpenTOC;
    var navigate = useNavigate();
    var handleTableRowClick = function (data) {
        var rowDetails = __assign({}, data);
        if (rowDetails.displayTransactionType === ETransactionType.SIP_INSTALLMENT &&
            rowDetails.displayStatus === EOrderBookStatus.ORDER_COMPLETED) {
            // Installments are the subsequent payments done for a main SIP. So, while navigating to sidebar, we display main SIP's details and all the available installments for completed installments.
            // Loading displaystatus as Active will handle the above defined sidebar case
            rowDetails.displayStatus = EOrderBookStatus.ACTIVE;
        }
        setOpenSB(true);
        setSelectedRowDetails(rowDetails);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: (_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "" },
            React.createElement(MutualFundTransactionsTable, { columns: props.tableColumns, data: props.tableData, rowOnClick: handleTableRowClick, showViewAll: props.showViewAll, viewAllOnClick: props === null || props === void 0 ? void 0 : props.viewAllOnClick, showShimmer: props === null || props === void 0 ? void 0 : props.showShimmer, selectedSortColumnVal: props === null || props === void 0 ? void 0 : props.defaultSortingColumnKey, errorScreenBtnCallback: function () {
                    return navigate("/dashboard/product-bouquet?productCode=56&categoryCode=261");
                } })),
        openSB && selectedRowDetails && (React.createElement(OrderBookSideBar, { openKey: openSB, setOpenKey: setOpenSB, rowData: selectedRowDetails, actioningFrom: ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE, setOpenTOC: setOpenTOC }))));
};
export default AllTransactions;
